// extracted by mini-css-extract-plugin
module.exports = {"article_container":"Article_article_container___pVIt","not_article":"Article_not_article__Kthb0"};